module.exports = {
	"id": "GU",
	"name": "Guam",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.005131,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.194978,
			"22": 0.010262,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.010262,
			"32": 0.005131,
			"33": null,
			"34": 0.010262,
			"35": 0.005131,
			"36": 0.015393,
			"37": 0.005131,
			"38": 0.020524,
			"39": 0.025655,
			"40": 0.015393,
			"41": 0.015393,
			"42": 0.010262,
			"43": 0.05131,
			"44": 0.020524,
			"45": 0.05131,
			"46": 0.025655,
			"47": 0.035917,
			"48": 0.030786,
			"49": 1.647051,
			"50": 0.076965,
			"51": 0.159061,
			"52": 0.554148,
			"53": 19.836446,
			"54": 6.275213,
			"55": 0.076965,
			"56": 0.010262,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": 0.041048,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.015393,
			"11": 0.010262,
			"12": 0.005131,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.030786,
			"39": 0.010262,
			"40": 0.005131,
			"41": 0.025655,
			"42": 0.041048,
			"43": 0.035917,
			"44": 0.005131,
			"45": 0.015393,
			"46": 0.025655,
			"47": 0.328384,
			"48": 0.420742,
			"49": 3.997049,
			"50": 0.05131,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005131,
			"29": 0.092358,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.020524,
			"34": null,
			"35": null,
			"36": 0.025655,
			"37": 0.277074,
			"38": null,
			"39": null,
			"40": 0.133406,
			"41": 0.015393,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.046179,
			"6": 0.015393,
			"7": 0.030786,
			"8": 0.328384,
			"9": 0.343777,
			"10": 2.25764,
			"3.1": null,
			"3.2": null,
			"5.1": 0.097489,
			"6.1": 0.112882,
			"7.1": 0.015393,
			"9.1": 1.934387
		},
		"ios_saf": {
			"8": 0,
			"10": 15.9464723564,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.429738977935,
			"8.1-8.4": 0.793924552456,
			"9.0-9.2": 0.378752997502,
			"9.3": 5.77841111574
		},
		"android": {
			"3": 0,
			"4": 0.0553191731266,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00691489664083,
			"4.1": 0.199544160207,
			"4.2-4.3": 0.498860400517,
			"4.4": 1.14392147287,
			"4.4.3-4.4.4": 1.15379989664
		},
		"ie": {
			"6": null,
			"7": 0.0102867874396,
			"8": 0.169731992754,
			"9": 0.164588599034,
			"10": 0.159445205314,
			"11": 3.75467741546,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0255244542539,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000709012618165
		},
		"edge": {
			"12": 0.087227,
			"13": 0.856877,
			"14": 2.242247
		},
		"ie_mob": {
			"10": 0.0192056338028,
			"11": 0.0781943661972
		},
		"bb": {
			"7": 0.00487,
			"10": null
		},
		"samsung": {
			"0": 6.97871
		},
		"and_uc": {
			"0": 0.14123
		},
		"op_mini": {
			"0": 0.343886533128
		},
		"and_chr": {
			"0": 17.361527
		},
		"and_ff": {
			"0": 0.04383
		}
	},
	"total": 98.845097
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GU.json
 ** module id = 539
 ** module chunks = 0
 **/